// Función para detectar automáticamente la IP del servidor
const detectServerIP = (): string => {
  // Si estamos en desarrollo (localhost), usar localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'localhost';
  }
  
  // Si estamos en producción, usar la IP del servidor actual
  return window.location.hostname;
};

// Función para obtener el puerto del servidor
const detectServerPort = (): string => {
  // Si estamos en desarrollo local, usar el mismo puerto que la PWA
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return window.location.port;
  }
  
  // En producción, usar el puerto del navegador si existe, o ninguno (para usar proxy NGINX)
  return window.location.port || '';
};

// Función para construir la URL base del servidor
const buildServerURL = (): string => {
  const hostname = detectServerIP();
  const port = detectServerPort();
  const protocol = window.location.protocol;
  
  // Si no hay puerto, no incluir los dos puntos
  if (port) {
    return `${protocol}//${hostname}:${port}`;
  } else {
    return `${protocol}//${hostname}`;
  }
};

// Configuración de la aplicación
export const config = {
  // URLs del servidor - detectadas automáticamente
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || `${buildServerURL()}/api`,
  WS_URL: process.env.REACT_APP_WS_URL || buildServerURL(),
  PROXY_URL: process.env.REACT_APP_PROXY_URL || buildServerURL(),
  

  
  // Credenciales por defecto (vacías para seguridad)
  DEFAULT_EMAIL: process.env.REACT_APP_DEFAULT_EMAIL || '',
  DEFAULT_PASSWORD: process.env.REACT_APP_DEFAULT_PASSWORD || '',
  
  // Google Translate API Key (opcional, para traducción de términos de búsqueda)
  GOOGLE_TRANSLATE_API_KEY: process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY || '',
};

// Si serverUrl no es el origen de esta página (otro host, otro esquema o
// otro puerto), olvidarlo. Comparar solo el host dejaba https://IP guardado
// mientras la página está en http://IP: el ingreso iba al HTTPS con el
// certificado local y el navegador lo cortaba (Network Error). Lo mismo al
// revés, con contenido mixto.
export const syncServerUrlWithCurrentOrigin = (): void => {
  try {
    const savedUrl = localStorage.getItem('serverUrl');
    if (!savedUrl) return;
    const saved = new URL(savedUrl);
    const current = new URL(window.location.origin);
    if (saved.origin !== current.origin) {
      localStorage.removeItem('serverUrl');
    }
  } catch {
    localStorage.removeItem('serverUrl');
  }
};

// Función para obtener la URL del servidor desde localStorage o usar por defecto
export const getServerUrl = (): string => {
  syncServerUrlWithCurrentOrigin();
  const savedUrl = localStorage.getItem('serverUrl');
  if (savedUrl) {
    return savedUrl;
  }
  return config.WS_URL;
};

// Función para obtener la URL base de la API
export const getApiBaseUrl = (): string => {
  const serverUrl = getServerUrl();
  // Si tenemos una URL del servidor guardada, construir la URL de la API
  if (serverUrl && serverUrl !== config.WS_URL) {
    return `${serverUrl}/api`;
  }
  return config.API_BASE_URL;
};
